/**
 * Created by Allan on 2021/04/27.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/finance',
        meta:{
            title:'财务管理',
            icon:'el-icon-s-finance',
            menuId:'14'
        },
        component:Frame,
        children:[
            {
                path:'loan',
                name:'loanList',
                meta:{
                    title:'放款明细',
                    keepAlive:true,
                    menuId:'15'
                },
                component:resolve => require(['@/views/finance/loan/index'], resolve)
            },
            {
                path:'repayment',
                name:'repaymentList',
                meta:{
                    title:'还款明细',
                    keepAlive:true,
                    menuId:'16'
                },
                component:resolve => require(['@/views/finance/repayment/index'], resolve)
            },
            {
                path:'account',
                name:'accountMonitor',
                meta:{
                    title:'账户量监控',
                    keepAlive:true,
                    menuId:'82'
                },
                component:resolve => require(['@/views/finance/account/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/finance.js